var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg076Security(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.33 21.9728L12.3302 21.9728C13.3093 21.6834 21 19.4109 21 13V5.99999C21.0014 5.58152 20.742 5.20645 20.35 5.05999L12.35 2.05999C12.1235 1.97992 11.8765 1.97992 11.65 2.05999L3.65001 5.05999C3.258 5.20645 2.99865 5.58152 3.00001 5.99999V13C3.00001 19.4109 10.6908 21.6835 11.6698 21.9728L11.67 21.9728C11.7141 21.9858 11.7445 21.9948 11.76 22C11.9176 22.039 12.0824 22.039 12.24 22C12.2555 21.9948 12.2859 21.9858 12.33 21.9728ZM5.00001 6.68999L12 4.06999L19 6.68999V13C19 17.6 13.26 19.58 12 20C10.74 19.62 5.00001 17.64 5.00001 13V6.68999ZM11 14V12.72C10.3849 12.3649 10.0043 11.7102 10 11C10 9.89542 10.8954 8.99999 12 8.99999C13.1046 8.99999 14 9.89542 14 11C13.9957 11.7102 13.6151 12.3649 13 12.72V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg076Security);
export default __webpack_public_path__ + "static/media/076-security.423a99ec7934dac1b0c9effebc31a41f.svg";
export { ForwardRef as ReactComponent };